import React from "react";
import { Modal, Box, Typography, Button } from "@mui/material";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import { addChatWindow } from "../Redux/Slice/dataSlice";
import { useDispatch } from "react-redux";

const parseInterval = (interval) => {
  let minutes = 0;

  const hourMatch = interval.match(/(\d+)\s*Hour/);
  const minuteMatch = interval.match(/(\d+)\s*Minute/);

  if (hourMatch) {
    minutes += parseInt(hourMatch[1], 10) * 60;
  }

  if (minuteMatch) {
    minutes += parseInt(minuteMatch[1], 10);
  }

  return minutes;
};

const formatDateTime = (date) => {
  return date.toLocaleString([], {
    year: "numeric",
    month: "short",
    day: "numeric",
    hour: "2-digit",
    minute: "2-digit",
  });
};

const StartChat = ({ open, onClose, userData }) => {
  const dispatch = useDispatch();
  if (!userData) return null;

  const { userName, checkInType, interval, userId, userPhone } = userData;

  // console.log("handelChatWindoeOpen", userData);

  const minutesToAdd = parseInterval(interval);
  const nextCheckInDate = new Date(Date.now() + minutesToAdd * 60000);
  const nextCheckIn = formatDateTime(nextCheckInDate);

  const handelChatWindoeOpen = async () => {
    dispatch(
      addChatWindow({
        userId: userId,
        username: userName,
      })
    );
    onClose();
  };

  return (
    <Modal
      open={open}
      onClose={onClose}
      BackdropProps={{ invisible: true }}
      disableEnforceFocus
      disableAutoFocus
      disableRestoreFocus
    >
      <Box
        sx={{
          backgroundColor: "#fff",
          borderRadius: 2,
          width: 650,
          maxWidth: "90%",
          p: 4,
          boxShadow: 24,
          mx: "auto",
          mt: "15vh",
        }}
      >
        <h5 className="text-dark text-end pe-4" onClick={onClose} style={{ cursor: "pointer" }}>
          X
        </h5>
        <Box sx={{ display: "flex", alignItems: "center", mb: 2 }}>
          <CheckCircleIcon sx={{ color: "green", fontSize: 40, mr: 1 }} />
          <Typography variant="body1" fontWeight="bold">
            Next Check-In Notification
          </Typography>
        </Box>

        <Typography fontSize={16}>
          <strong>User:</strong> {userName}
        </Typography>
        <Typography fontSize={16}>
          <strong>Mode of Communication:</strong> {checkInType}
        </Typography>
        <Typography fontSize={16}>
          <strong>Interval:</strong> {interval}
        </Typography>
        <Typography fontSize={16}>
          <strong>Next Check-In Time:</strong> {nextCheckIn}
        </Typography>

        <Typography fontSize={15} sx={{ mt: 2 }}>
          You are scheduled to perform a {checkInType} based wellbeing check for {userName}.
        </Typography>
        <Typography fontSize={15} sx={{ mt: 2 }}>
          <strong>Important:</strong> Please initiate communication through the in-app chat
          interface. If there is no response within 5 minutes, consider dispatching support or
          escalating the case.
        </Typography>

        <Box sx={{ textAlign: "center", mt: 4 }}>
          {checkInType === "Phone-Call" ? (
            <Button
              variant="contained"
              color="secondary"
              onClick={() => {
                alert(`Call ${userName}. Mobile Number ${userPhone}`);
              }}
              sx={{ px: 4, py: 1.5, fontWeight: "bold", fontSize: 14, color: "#fff" }}
            >
              Call User Now
            </Button>
          ) : (
            <Button
              variant="contained"
              color="primary"
              onClick={handelChatWindoeOpen}
              sx={{ px: 4, py: 1.5, fontWeight: "bold", fontSize: 14, color: "#fff" }}
            >
              Start Chat Now
            </Button>
          )}
        </Box>
      </Box>
    </Modal>
  );
};

export default StartChat;
